import React from "react";
import { useAuthContext } from "../../context/AuthContext";
import { useState, useEffect } from "react";
import { getToken } from "../../helpers/authHelpers";
import axios from "axios";
import "./blogsettings.css";

const BlogSettings = () => {
  const [aboutBlog, setAboutBlog] = useState({});
  const [fileBlogPreview, setFileBlogPreview] = useState(null);
  const [fileAboutPreview, setFileAboutPreview] = useState(null);
  const [fileContactPreview, setFileContactPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const [blogFormData, setBlogFormData] = useState({
    title: "",
    description: "",
    instagram_url: "",
    twitter_url: "",
    email: "",
    contact_title: "",
    contact_desc: "",
    main_photo: "",
    about_photo: "",
    contact_photo: "",
  });

  useEffect(() => {
    const getAboutBlog = async () => {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/blog-infos?populate=*"
        // {
        //   headers: {
        //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
        //   },
        // }
      );

      // if (res.data.length > 0) {
      //only getting the first entry of the table
      let currentRes = res?.data?.data[0];

      setBlogFormData({
        title: currentRes.title || "",
        description: currentRes.description || "",
        instagram_url: currentRes.instagram_url || "",
        twitter_url: currentRes.twitter_url || "",
        email: currentRes.email || "",
        contact_title: currentRes.contact_title || "",
        contact_desc: currentRes.contact_desc || "",
        main_photo: currentRes.main_photo || "",
        about_photo: currentRes.about_photo || "",
        contact_photo: currentRes.contact_photo || "",
      });

      const previewUrl =
        process.env.REACT_APP_UPLOAD_URL + currentRes.main_photo?.url;
      setFileBlogPreview(previewUrl);

      const aboutPreviewUrl =
        process.env.REACT_APP_UPLOAD_URL + currentRes.about_photo?.url;
      setFileAboutPreview(aboutPreviewUrl);

      const contactPreviewUrl =
        process.env.REACT_APP_UPLOAD_URL + currentRes.contact_photo?.url;
      setFileContactPreview(contactPreviewUrl);
      // }
    };

    getAboutBlog();
  }, [aboutBlog]);

  //Clean up file preview URL on unmount
  useEffect(() => {
    return () => {
      if (fileBlogPreview) URL.revokeObjectURL(fileBlogPreview);
    };
  }, [fileBlogPreview]);

  function handleBlogSubmit() {}

  const handleRemoveBlogImage = () => {
    setBlogFormData((prev) => ({
      ...prev,
      // avatar_url: "",
      profilePic: "",
    }));
    setFileBlogPreview("");
  };

  const handleBlogChange = (e) => {
    const file = e.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      // Clean up old preview
      if (fileBlogPreview) URL.revokeObjectURL(fileBlogPreview);

      const previewUrl = URL.createObjectURL(file);

      setBlogFormData((prev) => ({
        ...prev,
        main_photo: file,
        // avatar_url: "", // clear if needed
      }));

      setFileBlogPreview(previewUrl);
    }
  };

  const handleRemoveContactImage = () => {
    setBlogFormData((prev) => ({
      ...prev,
      // avatar_url: "",
      contact_photo: "",
    }));
    setFileContactPreview("");
  };

  const handleRemoveAboutImage = () => {
    setBlogFormData((prev) => ({
      ...prev,
      // avatar_url: "",
      about_photo: "",
    }));
    setFileAboutPreview("");
  };

  return (
    <div>
      <h2>Blog Settings</h2>
      <form onSubmit={handleBlogSubmit}>
        <div className="row">
          {" "}
          <label>
            Title*:
            <input
              type="text"
              name="username"
              value={blogFormData.title}
              onChange={handleBlogChange}
              required
            />
          </label>
        </div>
        <div className="row">
          {fileBlogPreview ? (
            <>
              <img
                className="bsPreviewImg"
                src={fileBlogPreview}
                alt="Profile Preview"
              />
              <button
                type="button"
                className="d-flex"
                onClick={handleRemoveBlogImage}
              >
                Remove Image
              </button>
            </>
          ) : (
            <p>No image selected</p>
          )}

          <div className="row ">
            <label htmlFor="fileInput">
              Upload Main Blog image
              <i className="writeIcon fas fa-plus"></i>
              <input
                id="fileInput"
                type="file"
                name="profilePic"
                onChange={handleBlogChange}
                style={{ display: "none" }}
              />
            </label>

            <p>{fileBlogPreview}</p>
          </div>
        </div>

        <div className="row">
          <label>
            Description Blog:
            <textarea
              name="blog_description"
              value={blogFormData.description}
              onChange={handleBlogChange}
            ></textarea>
          </label>
        </div>
        <h3>Contact Settings</h3>
        <div className="row">
          <label>
            Instagram Url:
            <input
              type="text"
              name="instagram_url"
              value={blogFormData.instagram_url}
              onChange={handleBlogChange}
            />
          </label>

          <label>
            Twitter URL:
            <input
              type="url"
              name="twitter_url"
              value={blogFormData.twitter_url}
              onChange={handleBlogChange}
            />
          </label>
          <label>
            Email:
            <input
              type="url"
              name="email"
              value={blogFormData.email}
              onChange={handleBlogChange}
            />
          </label>
        </div>

        <div className="row">
          <label>
            Contact Title:
            <input
              type="text"
              name="contact_title"
              value={blogFormData.contact_title}
              onChange={handleBlogChange}
            />
          </label>
        </div>

        <div className="row">
          {fileContactPreview ? (
            <>
              <img
                className="bsPreviewImg"
                src={fileContactPreview}
                alt="Profile Preview"
              />
              <button
                type="button"
                className="d-flex"
                onClick={handleRemoveContactImage}
              >
                Remove Image
              </button>
            </>
          ) : (
            <p>No image selected</p>
          )}

          <div className="row ">
            <label htmlFor="fileInput">
              Upload Main Contact image
              <i className="writeIcon fas fa-plus"></i>
              <input
                id="fileContactInput"
                type="file"
                name="contactPic"
                onChange={handleBlogChange}
                style={{ display: "none" }}
              />
            </label>

            <p>{fileContactPreview}</p>
          </div>
        </div>

        <div className="row">
          <label>
            Contact Description:
            <textarea
              name="contact_desc"
              value={blogFormData.contact_desc}
              onChange={handleBlogChange}
            ></textarea>
          </label>
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Blog Settings"}
        </button>
      </form>
    </div>
  );
};

export default BlogSettings;
